import { styled } from "@mui/material";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

export const AccordionGroup = styled("div")({
  "& + &": {
    marginTop: "24px",
  },
});
export const AccordionGroupTitle = styled("p")({
  margin: "0 12px 12px",
  ...getFontStyle(FontSize.BodyMedium),
  fontWeight: "bold",
});
